import axios from 'axios';

export function updateCampaignStepCloud(campaignId, data) {
  return axios.post(`/api/?entity=campaigns&action=updatestepcloud&cid=${campaignId}`, data);
}
